import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useLocationState } from "./useLocationState";

export function useBackAction() {
  const history = useHistory();
  const locationState = useLocationState();

  return useCallback(() => {
    if (locationState?.referrer) {
      history.replace(locationState.referrer);
    } else {
      history.goBack();
    }
  }, [history, locationState?.referrer]);
}
